import React from 'react'
import { CSSProperties } from 'react'
import { Form } from 'react-bootstrap'

import TransitionMantineTooltip from '../TransitionMantineTooltip'

type TLabel = {
  tooltip?: React.ReactNode
  hideLabel?: boolean
  label?: React.ReactNode
  required?: boolean
  children?: React.ReactNode
  fontSize?: string | number
  styleToolTip?: CSSProperties
}

const Label = (props: TLabel): React.ReactElement => {
  const {
    tooltip,
    hideLabel,
    label,
    required,
    children,
    fontSize,
    styleToolTip = {},
  } = props

  return (
    <TransitionMantineTooltip tooltip={tooltip}>
      <Form.Label
        style={{
          marginBottom: '2px',
          opacity: hideLabel ? '0' : '1',
          position: 'relative',
          fontSize,
        }}
      >
        {label || children}
        {required && (
          <span style={{ color: '#f1556c', fontWeight: '800' as any }}>
            &nbsp;*
          </span>
        )}
        {tooltip && (
          <span
            className="ml-1"
            style={{
              fontSize: '1.2em',
              // position: 'absolute',
              marginTop: '-2px',
              ...styleToolTip,
            }}
          >
            <i className="fas fa-question-circle" />
          </span>
        )}
      </Form.Label>
    </TransitionMantineTooltip>
  )
}

export default Label
